import c from "./lib/createApi";

export default {
  gets: c("GET", "/v1/knscc", true), // [분야 - 1] 기술분류 불러오기
};
